/* Brand page (/collections/vendors?q=...) — transposes BrandDetail.tsx: fetches the
   vendor's full catalogue via the Storefront API, builds the category tree from
   product tags/types × the nav menu tree, and drives price/category/stock filters,
   sorting, and client-side pagination. */
(function () {
  var root = document.querySelector('[data-brand-root]');
  if (!root || root.dataset.brandInit) return;
  root.dataset.brandInit = '1';

  var vendor = root.dataset.vendor;
  var token = root.dataset.token;
  var loggedIn = root.dataset.loggedIn === '1';
  var gated = (root.dataset.gatedVendors || '')
    .split('|')
    .map(function (v) { return v.trim().toLowerCase().replace(/[^a-z0-9]/g, ''); })
    .filter(Boolean);

  var TREE = [];
  try {
    TREE = JSON.parse(root.querySelector('[data-brand-category-tree]').textContent);
  } catch (e) { /* sidebar simply omits categories */ }

  var el = {
    filters: root.querySelectorAll('[data-brand-filters]'),
    count: root.querySelector('[data-brand-count]'),
    countN: root.querySelector('[data-brand-count-n]'),
    catChips: root.querySelectorAll('[data-brand-cat-chip]'),
    sort: root.querySelector('[data-brand-sort]'),
    active: root.querySelector('[data-brand-active-filters]'),
    toolbar: root.querySelector('[data-brand-toolbar]'),
    showing: root.querySelector('[data-brand-showing]'),
    perPage: root.querySelector('[data-brand-per-page]'),
    loading: root.querySelector('[data-brand-loading]'),
    empty: root.querySelector('[data-brand-empty]'),
    grid: root.querySelector('[data-brand-grid]'),
    pagination: root.querySelector('[data-brand-pagination]'),
    mobileToggle: root.querySelector('[data-brand-mobile-toggle]'),
    filterCount: root.querySelector('[data-brand-filter-count]'),
  };

  var products = [];
  var maxPrice = 10000;
  var state = {
    price: [0, 10000],
    categories: [],
    inStock: false,
    sort: 'featured',
    page: 1,
    perPage: 24,
    sections: { category: true, price: true, availability: true },
    collapsed: {}, // category tree nodes are expanded by default, as on the live site
  };

  var norm = function (s) {
    return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  };

  function money(amount) { return '$' + parseFloat(amount).toFixed(2); }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }
  function minPrice(p) { return parseFloat(p.priceRange.minVariantPrice.amount); }

  /* ---------- data ---------- */

  // BEST_SELLING so the "Best selling" (default) order is the storefront's real one.
  var QUERY = 'query($n: Int!, $after: String, $q: String!) {' +
    ' products(first: $n, after: $after, query: $q, sortKey: BEST_SELLING) {' +
    '  edges { node { id title handle vendor tags productType availableForSale' +
    ' atl: metafield(namespace: "custom", key: "made_in_atlantic_canada") { value } origin: metafield(namespace: "custom", key: "country_of_origin") { value }' +
    '   priceRange { minVariantPrice { amount } }' +
    '   featuredImage { url altText }' +
    '   variants(first: 1) { edges { node { id price { amount } compareAtPrice { amount } availableForSale } } } } }' +
    '  pageInfo { hasNextPage endCursor } } }';

  function fetchPage(after, acc) {
    return fetch('https://' + window.Shopify.shop + '/api/2025-07/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': token },
      body: JSON.stringify({ query: QUERY, variables: { n: 250, after: after, q: 'vendor:"' + vendor.replace(/"/g, '\\"') + '"' } })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var conn = d.data && d.data.products;
        if (!conn) return acc;
        conn.edges.forEach(function (e) { acc.push(e.node); });
        if (conn.pageInfo.hasNextPage && acc.length < 1000) return fetchPage(conn.pageInfo.endCursor, acc);
        return acc;
      });
  }

  /* ---------- category tree ---------- */

  function availableCategories() {
    var slugs = {};
    products.forEach(function (p) {
      if (p.productType) slugs[norm(p.productType)] = 1;
      (p.tags || []).forEach(function (t) { slugs[norm(t)] = 1; });
    });
    var out = [];
    TREE.forEach(function (main) {
      var subs = [];
      (main.subs || []).forEach(function (sub) {
        var nested = (sub.subs || []).filter(function (n) { return slugs[n.slug]; });
        if (slugs[sub.slug] || nested.length) subs.push({ name: sub.name, slug: sub.slug, subs: nested });
      });
      if (slugs[main.slug] || subs.length) out.push({ name: main.name, slug: main.slug, subs: subs });
    });
    return out;
  }

  /* ---------- filtering / sorting / paging ---------- */

  function filtered() {
    var list = products.filter(function (p) {
      var price = minPrice(p);
      if (price < state.price[0] || price > state.price[1]) return false;
      if (state.inStock && !p.availableForSale) return false;
      if (state.categories.length) {
        var typeN = norm(p.productType);
        var tagsN = (p.tags || []).map(norm);
        var hit = state.categories.some(function (c) {
          return typeN === c || tagsN.indexOf(c) !== -1;
        });
        if (!hit) return false;
      }
      return true;
    });
    if (state.sort === 'price-low') list.sort(function (a, b) { return minPrice(a) - minPrice(b); });
    else if (state.sort === 'price-high') list.sort(function (a, b) { return minPrice(b) - minPrice(a); });
    else if (state.sort === 'name') list.sort(function (a, b) { return a.title.localeCompare(b.title); });
    return list;
  }

  function activeCount() {
    return (state.price[0] > 0 || state.price[1] < maxPrice ? 1 : 0) +
      state.categories.length + (state.inStock ? 1 : 0);
  }

  /* ---------- rendering ---------- */


  function badgesHtml(node) {
    var atl = node.atl && node.atl.value === 'true';
    var can = atl || (node.origin && node.origin.value === 'Canada');
    if (!atl && !can) return '';
    var h = '<div class="lum-pcard__badges">';
    if (atl && root.dataset.badgeAtlantic) h += '<img src="' + root.dataset.badgeAtlantic + '" alt="Made in Atlantic Canada" title="Made in Atlantic Canada" width="28" height="28" loading="lazy" class="lum-pcard__local">';
    if (can && root.dataset.badgeCanada) h += '<img src="' + root.dataset.badgeCanada + '" alt="Made in Canada" title="Made in Canada" width="28" height="28" loading="lazy" class="lum-pcard__local lum-pcard__local--canada">';
    return h + '</div>';
  }

  function cardHtml(node) {
    var v = node.variants.edges[0] ? node.variants.edges[0].node : null;
    var vendorNorm = (node.vendor || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    var isGated = gated.indexOf(vendorNorm) !== -1 && !loggedIn;
    var onSale = v && v.compareAtPrice && parseFloat(v.compareAtPrice.amount) > parseFloat(v.price.amount);
    var sep = node.featuredImage && node.featuredImage.url.indexOf('?') === -1 ? '?' : '&';
    var img = node.featuredImage
      ? '<img src="' + node.featuredImage.url + sep + 'width=400" alt="' + esc(node.title) + '" width="400" height="400" loading="lazy" decoding="async" class="max-w-full max-h-full w-auto h-auto object-contain group-hover:scale-105 transition-all duration-300" style="max-height:85%;max-width:85%">'
      : '<div class="text-muted-foreground text-sm">No image</div>';
    var priceBlock;
    if (isGated) {
      priceBlock = '<span class="text-sm text-primary font-medium flex items-center gap-1">Login to view price</span>' +
        '<a href="/account/login" class="inline-flex items-center justify-center rounded-md font-medium border border-input bg-background hover:bg-accent h-11 min-h-[44px] px-3 text-xs">Login</a>';
    } else {
      var sale = onSale ? '<span class="inline-flex items-center rounded-full text-[10px] px-1.5 py-0 h-4 bg-primary text-primary-foreground font-semibold">SALE</span>' : '';
      var compare = onSale ? '<span class="text-xs text-muted-foreground line-through">' + money(v.compareAtPrice.amount) + '</span>' : '';
      var buy = v && v.availableForSale
        ? '<form action="/cart/add" method="post" class="m-0"><input type="hidden" name="id" value="' + v.id.split('/').pop() + '"><input type="hidden" name="quantity" value="1">' +
          '<button type="submit" class="inline-flex items-center justify-center gap-1 rounded-md font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-11 min-h-[44px] px-3 text-xs transition-colors">Add</button></form>'
        : '<span class="inline-flex items-center justify-center rounded-md font-medium bg-primary text-primary-foreground opacity-50 h-11 min-h-[44px] px-3 text-xs">Out of Stock</span>';
      priceBlock = '<div class="flex flex-col gap-0.5">' + compare +
        '<div class="flex items-center gap-2"><span class="text-lg font-bold text-primary">' + (v ? money(v.price.amount) : '') + '</span>' + sale + '</div></div>' + buy;
    }
    return '<a href="/products/' + node.handle + '" class="group block lum-pcard">' +
      '<div class="relative w-full aspect-square bg-background overflow-hidden flex items-center justify-center p-3 sm:p-4 product-card__media">' + img + badgesHtml(node) + '</div>' +
      '<div class="p-3 space-y-2">' +
      '<span class="text-xs text-muted-foreground font-medium uppercase tracking-wide inline-block">' + esc(node.vendor) + '</span>' +
      '<h3 class="font-medium text-sm line-clamp-2 leading-5 group-hover:text-primary transition-colors min-h-[2.5rem]">' + esc(node.title) + '</h3>' +
      '<div class="flex items-center justify-between lum-cardfoot">' + priceBlock + '</div>' +
      '</div></a>';
  }

  var CHEV_UP = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m18 15-6-6-6 6"></path></svg>';
  var CHEV_DOWN = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="m6 9 6 6 6-6"></path></svg>';
  var CHEV_UP_SM = CHEV_UP.replace('h-4 w-4', 'h-3 w-3');
  var CHEV_DOWN_SM = CHEV_DOWN.replace('h-4 w-4', 'h-3 w-3');

  // how many of the vendor's products sit under a category slug (type or tag)
  function slugCount(slug) {
    var n = 0;
    products.forEach(function (p) {
      if (norm(p.productType) === slug || (p.tags || []).some(function (t) { return norm(t) === slug; })) n++;
    });
    return n;
  }

  function checkboxRow(slug, name, key, hasKids) {
    var checked = state.categories.indexOf(slug) !== -1;
    return '<div class="lum-facet__opt-row"><label class="lum-facet__opt">' +
      '<input type="checkbox" data-cat="' + esc(slug) + '"' + (checked ? ' checked' : '') + '>' +
      '<span>' + esc(name) + '</span>' +
      '<span class="lum-facet__count">' + slugCount(slug) + '</span>' +
      '</label>' +
      (hasKids ? '<button type="button" data-cat-toggle="' + esc(key) + '" class="lum-bfilt__tog" aria-label="Toggle">' +
        (state.collapsed[key] ? CHEV_DOWN_SM : CHEV_UP_SM) + '</button>' : '') +
      '</div>';
  }

  function filtersHtml() {
    var cats = availableCategories();
    var n = activeCount();
    var h = '<div class="lum-bfilt__head"><span class="lum-facets__title">Filter</span>' +
      (n > 0 ? '<button type="button" data-clear-all class="lum-bfilt__clear">Clear all (' + n + ')</button>' : '') + '</div>';

    if (cats.length) {
      h += '<div class="lum-facet"><p class="lum-facet__label">Category</p><div class="lum-bfilt__tree">';
      cats.forEach(function (main) {
        var mKey = 'main-' + main.slug;
        h += '<div>' + checkboxRow(main.slug, main.name, mKey, main.subs.length > 0);
        if (main.subs.length && !state.collapsed[mKey]) {
          h += '<div class="lum-bfilt__sub">';
          main.subs.forEach(function (sub) {
            var sKey = 'subcat-' + sub.slug;
            h += '<div>' + checkboxRow(sub.slug, sub.name, sKey, sub.subs.length > 0);
            if (sub.subs.length && !state.collapsed[sKey]) {
              h += '<div class="lum-bfilt__sub">';
              sub.subs.forEach(function (nested) { h += checkboxRow(nested.slug, nested.name, '', false); });
              h += '</div>';
            }
            h += '</div>';
          });
          h += '</div>';
        }
        h += '</div>';
      });
      h += '</div></div>';
    }

    var pct = function (v) { return maxPrice ? (v / maxPrice * 100) : 0; };
    h += '<div class="lum-facet"><p class="lum-facet__label">Price</p>' +
      '<div class="brand-slider">' +
      '<div class="brand-slider-track"></div>' +
      '<div class="brand-slider-range" style="left:' + pct(state.price[0]) + '%;width:' + (pct(state.price[1]) - pct(state.price[0])) + '%"></div>' +
      '<input type="range" data-price-min min="0" max="' + maxPrice + '" step="5" value="' + state.price[0] + '" aria-label="Minimum price">' +
      '<input type="range" data-price-max min="0" max="' + maxPrice + '" step="5" value="' + state.price[1] + '" aria-label="Maximum price">' +
      '</div>' +
      '<div class="lum-bfilt__range"><span>$' + state.price[0] + '</span><span>$' + state.price[1] + '</span></div></div>';

    h += '<div class="lum-facet"><p class="lum-facet__label">Availability</p>' +
      '<label class="lum-facet__opt"><input type="checkbox" data-in-stock' + (state.inStock ? ' checked' : '') + '><span>In stock only</span><span class="lum-facet__count">' +
      products.filter(function (p) { return p.availableForSale; }).length + '</span></label></div>';
    return h;
  }

  function badge(label, attr) {
    return '<button type="button" ' + attr + ' class="lum-chip">' + esc(label) + '<span aria-hidden="true">×</span><span class="sr-only">Remove filter</span></button>';
  }

  function slugName(slug) {
    var found = null;
    TREE.forEach(function (m) {
      if (m.slug === slug) found = m.name;
      (m.subs || []).forEach(function (s) {
        if (s.slug === slug) found = s.name;
        (s.subs || []).forEach(function (x) { if (x.slug === slug) found = x.name; });
      });
    });
    return found || slug;
  }

  function activeFiltersHtml() {
    var n = activeCount();
    if (!n) return '';
    var h = '<div class="lum-chips">';
    state.categories.forEach(function (c) { h += badge(slugName(c), 'data-remove-cat="' + esc(c) + '"'); });
    if (state.price[0] !== 0 || state.price[1] !== maxPrice) h += badge('$' + state.price[0] + '–$' + state.price[1], 'data-remove-price');
    if (state.inStock) h += badge('In stock', 'data-remove-stock');
    if (n >= 2) h += '<button type="button" data-clear-all class="lum-chip lum-chip--clear">Clear all</button>';
    return h + '</div>';
  }

  function pageBtn(page, label, disabled, active) {
    return '<button type="button" data-page="' + page + '"' + (disabled ? ' disabled' : '') +
      ' class="lum-bpage' + (active ? ' is-active' : '') + '">' + label + '</button>';
  }

  function render() {
    var list = filtered();
    var total = list.length;
    var pages = Math.max(1, Math.ceil(total / state.perPage));
    if (state.page > pages) state.page = pages;
    var start = (state.page - 1) * state.perPage;
    var slice = list.slice(start, start + state.perPage);

    el.filters.forEach(function (c) { c.innerHTML = filtersHtml(); });
    if (el.countN) el.countN.textContent = total;
    el.count.textContent = (total === 1 ? 'product' : 'products') + (activeCount() ? ' · filtered' : '');
    el.catChips.forEach(function (chip) {
      chip.classList.toggle('is-on', state.categories.indexOf(chip.getAttribute('data-brand-cat-chip')) !== -1);
    });
    var n = activeCount();
    el.filterCount.style.display = n ? '' : 'none';
    el.filterCount.textContent = n;
    el.active.style.display = n ? '' : 'none';
    el.active.innerHTML = activeFiltersHtml();

    el.empty.style.display = total > 0 ? 'none' : '';
    el.toolbar.style.display = total === 0 ? 'none' : '';
    el.showing.textContent = total ? 'Showing ' + (start + 1) + '-' + Math.min(start + state.perPage, total) + ' of ' + total + ' products' : '';
    el.grid.innerHTML = slice.map(cardHtml).join('');

    var ph = '';
    if (pages > 1) {
      ph += pageBtn(state.page - 1, '‹ Previous', state.page === 1, false);
      for (var p = 1; p <= pages; p++) {
        if (p === 1 || p === pages || (p >= state.page - 1 && p <= state.page + 1)) {
          ph += pageBtn(p, p, false, p === state.page);
        } else if (p === state.page - 2 || p === state.page + 2) {
          ph += '<span class="px-2 text-muted-foreground">…</span>';
        }
      }
      ph += pageBtn(state.page + 1, 'Next ›', state.page === pages, false);
    }
    el.pagination.innerHTML = ph;
  }

  /* ---------- events (delegated so re-renders keep working) ---------- */

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-cat')) {
      var slug = t.getAttribute('data-cat');
      var i = state.categories.indexOf(slug);
      if (t.checked && i === -1) state.categories.push(slug);
      if (!t.checked && i !== -1) state.categories.splice(i, 1);
      state.page = 1; render();
    } else if (t.hasAttribute('data-in-stock')) {
      state.inStock = t.checked; state.page = 1; render();
    } else if (t === el.sort) {
      state.sort = t.value; state.page = 1; render();
    } else if (t === el.perPage) {
      state.perPage = parseInt(t.value, 10); state.page = 1; render();
    }
  });

  root.addEventListener('input', function (e) {
    var t = e.target;
    if (t.hasAttribute('data-price-min') || t.hasAttribute('data-price-max')) {
      var slider = t.closest('.brand-slider');
      var lo = parseInt(slider.querySelector('[data-price-min]').value, 10);
      var hi = parseInt(slider.querySelector('[data-price-max]').value, 10);
      state.price = [Math.min(lo, hi), Math.max(lo, hi)];
      state.page = 1;
      clearTimeout(root._priceT);
      root._priceT = setTimeout(render, 150);
    }
  });

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-brand-cat-chip')) {
      // highlight-strip chips toggle the same category filter as the sidebar
      var chipSlug = t.getAttribute('data-brand-cat-chip');
      var ci = state.categories.indexOf(chipSlug);
      if (ci === -1) state.categories = [chipSlug]; else state.categories.splice(ci, 1);
      state.page = 1; render();
      var cat = document.getElementById('brand-catalogue');
      if (cat) cat.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (t.hasAttribute('data-cat-toggle')) {
      var key = t.getAttribute('data-cat-toggle');
      state.collapsed[key] = !state.collapsed[key]; render();
    } else if (t.hasAttribute('data-clear-all')) {
      state.categories = []; state.price = [0, maxPrice]; state.inStock = false; state.page = 1; render();
    } else if (t.hasAttribute('data-remove-cat')) {
      var slug2 = t.getAttribute('data-remove-cat');
      state.categories = state.categories.filter(function (c) { return c !== slug2; });
      state.page = 1; render();
    } else if (t.hasAttribute('data-remove-price')) {
      state.price = [0, maxPrice]; state.page = 1; render();
    } else if (t.hasAttribute('data-remove-stock')) {
      state.inStock = false; state.page = 1; render();
    } else if (t.hasAttribute('data-page')) {
      state.page = parseInt(t.getAttribute('data-page'), 10);
      render();
      window.scrollTo({ top: root.querySelector('[data-brand-grid]').offsetTop - 160, behavior: 'smooth' });
    }
  });

  // mobile filters slide-over
  if (el.mobileToggle) {
    var panel = document.createElement('div');
    panel.setAttribute('data-brand-mobile-panel', '');
    panel.innerHTML = '<div class="panel-scrim" data-panel-close></div>' +
      '<div class="panel-body"><div class="flex items-center justify-between mb-4">' +
      '<span class="lum-facets__title">Filter</span>' +
      '<button type="button" data-panel-close class="h-8 w-8 inline-flex items-center justify-center rounded-md hover:bg-accent" aria-label="Close filters">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>' +
      '</button></div><div data-brand-filters></div>' +
      '<button type="button" data-panel-close class="lum-btn lum-btn--primary" style="width:100%;margin-top:18px">Show results</button></div>';
    root.appendChild(panel);
    el.filters = root.querySelectorAll('[data-brand-filters]');
    el.mobileToggle.addEventListener('click', function () { panel.classList.add('open'); });
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-panel-close]')) panel.classList.remove('open');
    });
  }

  /* ---------- boot ---------- */

  if (!vendor || !token || !window.Shopify || !window.Shopify.shop) return;
  fetchPage(null, [])
    .then(function (all) {
      products = all;
      var prices = products.map(minPrice);
      maxPrice = prices.length ? Math.ceil(Math.max.apply(null, prices) / 10) * 10 : 10000;
      state.price = [0, maxPrice];
      el.loading.style.display = 'none';
      if (!products.length) { el.empty.style.display = ''; return; }
      render();
    })
    .catch(function () {
      el.loading.style.display = 'none';
      el.empty.style.display = '';
    });
})();
